import "./index.css";

import { lazy, Suspense } from "react";

import { createRoot } from "react-dom/client";

import { initAmplify } from "./v2/api/auth/config";
import { FullScreenSpinner } from "./v2/components/common";
import { FeatureFlagProvider } from "./v2/helpers/featureFlags";

const App = lazy(() => import("./App"));

const render = () => {
  const hasCognitoCookies =
    document.cookie &&
    document.cookie
      .split(";")
      .filter((value) => value.match(/CognitoIdentityService.*/)).length > 0;
  if (hasCognitoCookies) {
    initAmplify();
  }

  const rootElement = document.getElementById("root");
  if (!rootElement) {
    throw new Error("root element not found");
  }
  const root = createRoot(rootElement);
  root.render(
    <Suspense fallback={<FullScreenSpinner />}>
      <FeatureFlagProvider>
        <App />
      </FeatureFlagProvider>
    </Suspense>,
  );
};

render();
